// extracted by mini-css-extract-plugin
module.exports = {"markdown":"VMarkdownContent_markdown_2Wk8c"};